import { EVENTS_API_BASE } from '../config/api';

const coerceToSafeImageUrl = (value: string): string => {
  const trimmed = String(value || '').trim();
  if (!trimmed) return '';

  const normalizedEventsApiBase = String(EVENTS_API_BASE || '').replace(/\/$/, '');

  if (/^http:\/\/localhost:4000\/uploads\//i.test(trimmed) || /^http:\/\/127\.0\.0\.1:4000\/uploads\//i.test(trimmed)) {
    return trimmed.replace(/^http:\/\/(localhost|127\.0\.0\.1):4000/i, normalizedEventsApiBase);
  }

  if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
    if (/^http:\/\/cf\.geekdo-images\.com\//i.test(trimmed)) {
      return trimmed.replace(/^http:\/\//i, 'https://');
    }

    if (/^http:\/\/images\.geekdo\.com\//i.test(trimmed)) {
      return trimmed.replace(/^http:\/\//i, 'https://');
    }

    if (/^http:\/\/boardgamegeek\.com\//i.test(trimmed)) {
      return trimmed.replace(/^http:\/\//i, 'https://');
    }
  }

  return trimmed;
};

export const normalizeImageUrl = (image: any): string => {
  if (!image) return '';

  if (typeof image === 'string') return coerceToSafeImageUrl(image);

  if (typeof image?.url === 'string') return coerceToSafeImageUrl(image.url);

  if (typeof image?.imageUrl === 'string') return coerceToSafeImageUrl(image.imageUrl);

  if (image?.url && typeof image.url === 'object') {
    if (typeof image.url.url === 'string') return coerceToSafeImageUrl(image.url.url);
    if (typeof image.url.imageUrl === 'string') return coerceToSafeImageUrl(image.url.imageUrl);
  }

  if (image?.imageUrl && typeof image.imageUrl === 'object') {
    if (typeof image.imageUrl.url === 'string') return coerceToSafeImageUrl(image.imageUrl.url);
  }

  return '';
};

export const normalizeImageUrls = (images: any): string[] => {
  if (!Array.isArray(images)) return [];
  return images.map(normalizeImageUrl).filter((url): url is string => Boolean(url));
};

export const getImageSourceLabel = (image: any, fallbackToBgg = false): string => {
  const source = String(image?.source || image?.imageSource || '').toLowerCase();
  if (source === 'boardgamegeek' || source === 'bgg') return 'BoardGameGeek image';
  if (source === 'member-upload' || source === 'manual') return 'Member-uploaded photo';
  return fallbackToBgg ? 'BoardGameGeek image' : 'Member-uploaded photo';
};
